const mallLogin = () => import('@/views/mall/login');
const mallHome = () => import('@/views/mall/home');
const patientHome = () => import('@/views/mall/patientHome');
const mallCategory = () => import('@/views/mall/category');
const mallCart = () => import('@/views/mall/cart');
const mallPrescription = () => import('@/views/mall/prescription');
const mallProductDetail = () => import('@/views/mall/productDetail');
const mallPersonal = () => import('@/views/mall/personal');
const mallInfoEdit = () => import('@/views/mall/infoEdit');
const mallInfoEditAdd = () => import('@/views/mall/infoEditAdd');
const mallBuy = () => import('@/views/mall/buy');
const mallOrderConfirm = () => import('@/views/mall/orderConfirm');
const mallOrderDetail = () => import('@/views/mall/orderDetail');
const mallMyOrder = () => import('@/views/mall/myOrder');
const mallMyAddress = () => import('@/views/mall/myAddress');
const mallAddressEdit = () => import('@/views/mall/addressEdit');
const mallPointsDetails = () => import('@/views/mall/pointsDetails');
const mallEquityCard = () => import('@/views/mall/equityCard');
const mallSearch = () => import('@/views/mall/search');
const mallLogistics = () => import('@/views/mall/logistics');
const mallIntroduce = () => import('@/views/mall/introduce');
const mallPrescriptionDetail = () => import('@/views/mall/prescription/detail');
const mallMedicineList = () => import('@/views/mall/medicine');
const mallMedicineEdit = () => import('@/views/mall/medicine/edit');
const mallCategoryList = () => import('@/views/mall/category/categoryList');

export default [
  {
    path: '/mall-login',
    name: 'mallLogin',
    component: mallLogin,
    meta: {
      title: '登录',
      hideBack: true,
      noAuth: true
    }
  },
  {
    path: '/patient-home',
    name: 'patientHome',
    component: patientHome,
    meta: {
      title: '首页',
      hideBack: true,
      keeps: []
    }
  },
  {
    path: '/mall-home',
    name: 'mallHome',
    component: mallHome,
    meta: {
      title: '商城',
      hideBack: true,
      keeps: ['mallProductDetail', 'mallCategoryList', 'mallSearch', 'mallCategory', 'mallCart', 'mallPersonal']
    }
  },
  {
    path: '/mall-category',
    name: 'mallCategory',
    component: mallCategory,
    meta: {
      title: '分类',
      hideBack: true,
      noAuth: true,
      keeps: ['mallProductDetail', 'mallSearch', 'mallHome', 'mallCart', 'mallPersonal']
    }
  },
  {
    path: '/mall-cart',
    name: 'mallCart',
    component: mallCart,
    meta: {
      title: '购物车',
      hideBack: true,
      noAuth: true
    }
  },
  {
    path: '/mall-product-detail',
    name: 'mallProductDetail',
    component: mallProductDetail,
    meta: {
      title: '商品详情',
      noAuth: true
    }
  },
  {
    path: '/mall-personal',
    name: 'mallPersonal',
    component: mallPersonal,
    meta: {
      title: '我的',
      hideBack: true
    }
  },
  {
    path: '/mall-info-edit',
    name: 'mallInfoEdit',
    component: mallInfoEdit,
    meta: {
      title: '基本信息'
    }
  },
  {
    path: '/mall-info-edit-add',
    name: 'mallInfoEditAdd',
    component: mallInfoEditAdd,
    meta: {
      title: '基本信息'
    }
  },
  {
    path: '/mall-buy',
    name: 'mallBuy',
    component: mallBuy,
    meta: {
      title: '服务购买'
    }
  },
  {
    path: '/mall-order-confirm',
    name: 'mallOrderConfirm',
    component: mallOrderConfirm,
    meta: {
      title: '确认订单',
      keeps: ['mallMyAddress']
    }
  },
  {
    path: '/mall-order-detail',
    name: 'mallOrderDetail',
    component: mallOrderDetail,
    meta: {
      title: '订单详情',
      keeps: ['mallMyAddress']
    }
  },
  {
    path: '/mall-my-order',
    name: 'mallMyOrder',
    component: mallMyOrder,
    meta: {
      title: '我的订单',
      keeps: ['mallOrderDetail']
    }
  },
  {
    path: '/mall-my-address',
    name: 'mallMyAddress',
    component: mallMyAddress,
    meta: {
      title: '我的收货地址',
      keeps: ['mallOrderConfirm']
    }
  },
  {
    path: '/mall-address-edit',
    name: 'mallAddressEdit',
    component: mallAddressEdit,
    meta: {
      title: '编辑地址'
    }
  },
  {
    path: '/mall-equity-card',
    name: 'mallEquityCard',
    component: mallEquityCard,
    meta: {
      title: '权益卡'
    }
  },
  {
    path: '/mall-search',
    name: 'mallSearch',
    component: mallSearch,
    meta: {
      title: '搜索',
      keeps: ['mallProductDetail']
    }
  },
  {
    path: '/mall-logistics',
    name: 'mallLogistics',
    component: mallLogistics,
    meta: {
      title: '物流详情'
    }
  },
  {
    path: '/mall-introduce',
    name: 'mallIntroduce',
    component: mallIntroduce,
    meta: {
      title: '介绍'
    }
  },
  {
    path: '/mall-points-details',
    name: 'mallPointsDetails',
    component: mallPointsDetails,
    meta: {
      title: '积分明细'
    }
  },
  {
    path: '/mall-prescription',
    name: 'mallPrescription',
    component: mallPrescription,
    meta: {
      title: '填写问诊信息',
      keeps: ['mallMedicineAdd', 'mallMedicineEdit']
    }
  },
  {
    path: '/mall-prescription-detail',
    name: 'mallPrescriptionDetail',
    component: mallPrescriptionDetail,
    meta: {
      title: '处方详情'
    }
  },
  {
    path: '/mall/medicine',
    name: 'mallMedicineList',
    component: mallMedicineList,
    meta: {
      title: '用药人管理'
    }
  },
  {
    path: '/mall/medicine/add',
    name: 'mallMedicineAdd',
    component: mallMedicineEdit,
    meta: {
      title: '新建用药人'
    }
  },
  {
    path: '/mall/medicine/edit/:id',
    name: 'mallMedicineEdit',
    component: mallMedicineEdit,
    meta: {
      title: '编辑用药人'
    }
  },
  {
    path: '/mall-category-list',
    name: 'mallCategoryList',
    component: mallCategoryList,
    meta: {
      title: '分类商品',
      noAuth: true,
      keeps: ['mallProductDetail']
    }
  }
];
